import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  type MenuItemProps,
} from '@mui/material';
import { ManageAccountsOutlined as AccountSettingsIcon } from '@mui/icons-material';
import { useState } from 'react';
import Dialog from '@/components/Dialog';
import MicrosoftAccountSettings from './MicrosoftAccountSettings';
import GoogleAccountSettings from './GoogleAccountSettings';
import { FormattedMessage } from 'react-intl';
import type React from 'react';

type ConnectedAccountsSettingsProps = Omit<MenuItemProps, 'onClick'>;

const ConnectedAccountsSettings = (props: ConnectedAccountsSettingsProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <MenuItem onClick={() => setDialogOpen(true)} {...props}>
        <ListItemIcon>
          <AccountSettingsIcon />
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage id="portfolio.challenge.files.add.menu.items.connected_accounts" />
        </ListItemText>
      </MenuItem>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        // We need this to prevent the menu focus management from breaking the
        // dialog focus management
        onKeyDownCapture={(e: React.KeyboardEvent<HTMLDivElement>): void => {
          e.stopPropagation();

          if (e.key === 'Escape') {
            setDialogOpen(false);
          }
        }}
        onKeyUpCapture={(e: React.KeyboardEvent<HTMLDivElement>): void => {
          e.stopPropagation();
        }}
      >
        <Dialog.Title>
          <FormattedMessage id="portfolio.challenge.files.add.connected_accounts_dialog.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessage id="portfolio.challenge.files.add.connected_accounts_dialog.text" />
          </Dialog.ContentText>
          <GoogleAccountSettings />
          <MicrosoftAccountSettings />
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.DoneButton onClick={() => setDialogOpen(false)} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default ConnectedAccountsSettings;
